import { DataSourceType } from '@prisma/client';
import { InternalDataSource } from './enums';

/** User-facing labels for `DataSourceType` — do not render raw enum keys in UI */
export const DATA_SOURCE_TYPE_LABEL: Record<DataSourceType, string> = {
  [DataSourceType.INTERNAL]: 'Internal',
};

/** User-facing labels for `InternalDataSource` — do not render raw enum keys in UI */
export const INTERNAL_DATA_SOURCE_LABEL: Record<InternalDataSource, string> = {
  [InternalDataSource.BUSINESS_ENTITY_BY_ID]: 'Business entity',
  [InternalDataSource.DIRECTOR_BY_ID]: 'Director',
  [InternalDataSource.WORK_REQUEST_BY_ID]: 'Work request',
};

export function getDataSourceTypeLabel(type: DataSourceType): string {
  return DATA_SOURCE_TYPE_LABEL[type] ?? String(type);
}

export function getInternalDataSourceLabel(
  value: InternalDataSource | string | null | undefined
): string {
  if (value == null || value === '') return '—';
  if (value in INTERNAL_DATA_SOURCE_LABEL) {
    return INTERNAL_DATA_SOURCE_LABEL[value as InternalDataSource];
  }
  return String(value);
}

/** Single line for list/detail: type plus internal variant when present */
export function formatDataSourceTypeForTable(row: {
  type: DataSourceType;
  internalDataSource?: InternalDataSource | null;
}): string {
  const base = getDataSourceTypeLabel(row.type);
  if (row.type === DataSourceType.INTERNAL && row.internalDataSource) {
    return `${base} · ${getInternalDataSourceLabel(row.internalDataSource)}`;
  }
  return base;
}

/** US locale, human-readable date/time for admin lists */
export function formatDatasourceCreatedAt(
  value: Date | string | null | undefined
): string {
  if (value == null) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
